export function getCurrentTimezone(): number {
  return -new Date().getTimezoneOffset() / 60
}
